module.exports = __webpack_public_path__ + "static/media/logo.d1fe9fa5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/logo.png
// module id = 89
// module chunks = 0